/*
 *
 * Profile Actions
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 05-Sep-2024
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index'

export const actionTypes = {
  DO_GET_ALERTS_STATUS: '@@Profile/get_alerts_status',
  DO_PUT_ALERTS_STATUS: '@@Profile/put_alerts_status',
  DO_GET_SETTINGS: '@@Profile/get_settings',
  DO_POST_SETTINGS: '@@Profile/post_settings',
  DO_SET_FORM: '@@NexiExclusive/do_set_form',
  DO_GET_COMPANIES: '@@Profile/get_companies',
  DO_RESET_BANK_STATEMENT: '@@Profile/reset_bank_statement',
  DO_GET_COMPANY_SETTINGS: '@@Profile/get_company_settings',
  DO_GET_SHOP_SETTINGS: '@@Profile/get_shop_settings',
  DO_POST_BANK_STATEMENT: '@@Profile/post_bank_statement',
  DO_SET_CHANNEL: '@@Profile/do_set_channel',
  DO_GET_SETTING_STATE: '@@Profile/get_setting_state',
  // @generator action:route:type
  ...createRequestTypes('@@Profile', 'GET_ALERTS_STATUS'),
  ...createRequestTypes('@@Profile', 'PUT_ALERTS_STATUS'),
  ...createRequestTypes('@@Profile', 'GET_SETTINGS'),
  ...createRequestTypes('@@Profile', 'GET_COMPANIES'),
  ...createRequestTypes('@@Profile', 'GET_COMPANY_SETTINGS'),
  ...createRequestTypes('@@Profile', 'GET_SHOP_SETTINGS'),
  ...createRequestTypes('@@Profile', 'POST_BANK_STATEMENT'),
  ...createRequestTypes('@@Profile', 'GET_SETTING_STATE')
  // @generator action:route:type:request
}

// ------------------------------------
// Actions
// ------------------------------------

// @generator action:route:request
/** @action request
* * Insert a description
* @name getSettingState
* @return {object} - The action object
*/
export const getSettingState = new MakeRequest('Profile', 'get_setting_state')
/** @action request
* * Insert a description
* @name getShopSettings
* @return {object} - The action object
*/
export const getShopSettings = new MakeRequest('Profile', 'get_shop_settings')
/** @action request
* * Insert a description
* @name getCompanySettings
* @return {object} - The action object
*/
export const getCompanySettings = new MakeRequest('Profile', 'get_company_settings')

/** @action request
* * Insert a description
* @name getCompanies
* @return {object} - The action object
*/
export const getCompanies = new MakeRequest('Profile', 'get_companies')

/** @action request
 * * Insert a description
 * @name getAlertsStatus
 * @return {object} - The action object
 */
export const getAlertsStatus = new MakeRequest('Profile', 'get_alerts_status')

/** @action request
 * * Insert a description
 * @name putAlertsStatus
 * @return {object} - The action object
 */
export const putAlertsStatus = new MakeRequest('Profile', 'put_alerts_status')

/** @action request
 * * Insert a description
 * @name getSettings
 * @return {object} - The action object
 */
export const getSettings = new MakeRequest('Profile', 'get_settings')

/** @action request
 * * Insert a description
 * @name postSettings
 * @return {object} - The action object
 */
export const postSettings = new MakeRequest('Profile', 'post_settings')

/** @action request
 * * Insert a description
 * @name postBankStatement
 * @return {object} - The action object
 */
export const postBankStatement = new MakeRequest('Profile', 'post_bank_statement')

// @generator action:route
/** @action
* * Insert a description
* @name GetSettingState
* @return {object} - The payload object
*/
export const doGetSettingState = payload => createAction(actionTypes.DO_GET_SETTING_STATE, { payload })
/** @action
* * Insert a description
* @name PostBankStatement
* @return {object} - The payload object
*/
export const doPostBankStatement = payload => createAction(actionTypes.DO_POST_BANK_STATEMENT, { payload })
/** @action
* * Insert a description
* @name GetShopSettings
* @return {object} - The payload object
*/
export const doGetShopSettings = payload => createAction(actionTypes.DO_GET_SHOP_SETTINGS, { payload })
/** @action
* * Insert a description
* @name GetCompanySettings
* @return {object} - The payload object
*/
export const doGetCompanySettings = payload => createAction(actionTypes.DO_GET_COMPANY_SETTINGS, { payload })
/** @action
* * Insert a description
* @name GetCompanies
* @return {object} - The payload object
*/
export const doGetCompanies = payload => createAction(actionTypes.DO_GET_COMPANIES, { payload })

export const doResetBankStatement = payload => createAction(actionTypes.DO_RESET_BANK_STATEMENT, { payload })

/** @action
 * * Insert a description
 * @name doGetAlertsStatus
 * @return {object} - The payload object
 */
export const doGetAlertsStatus = (payload) => createAction(actionTypes.DO_GET_ALERTS_STATUS, { payload })

/** @action
 * * Insert a description
 * @name doPutAlertsStatus
 * @return {object} - The payload object
 */
export const doPutAlertsStatus = (payload) => createAction(actionTypes.DO_PUT_ALERTS_STATUS, { payload })

/** @action
* * Insert a description
* @name doGetSettings
* @return {object} - The payload object
*/
export const doGetSettings = payload => createAction(actionTypes.DO_GET_SETTINGS, { payload })

/** @action
* * Insert a description
* @name doPostSettings
* @return {object} - The payload object
*/
export const doPostSettings = (payload, edit) => createAction(actionTypes.DO_POST_SETTINGS, { payload, edit })

/** @action
* * Insert a description
* @name doSetForm
* @return {object} - The payload object
*/
export const doSetForm = (payload, callback) => createAction(actionTypes.DO_SET_FORM, { payload, meta: { callback } })

/** @action
* * Insert a description
* @name doSetChannel
* @return {object} - The payload object
*/
export const doSetChannel = (payload, callback) => createAction(actionTypes.DO_SET_CHANNEL, { payload, meta: { callback } })
